import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Campo } from '../../../models/coleta';
import { PROPRIEDADES } from '../util/constants';

@Component({
  selector: 'app-input-checkbox',
  templateUrl: './input-checkbox.component.html',
  styleUrls: ['./input-checkbox.component.scss'],
})
export class InputCheckboxComponent {
  @Input()
  currentFormControl: UntypedFormControl = new UntypedFormControl();
  internalCampo: Campo = {};
  placeholder = '';
  description = '';

  constructor() {}

  get campo(): Campo {
    return this.internalCampo;
  }

  @Input()
  set campo(campo: Campo) {
    this.placeholder =
      campo.atributos?.find(
        (item) => item.propriedade === PROPRIEDADES.PLACEHOLDER
      )?.valor ?? '';
    this.description = campo.descricao ?? '';
    this.internalCampo = campo;
  }
}
